module.exports = __webpack_public_path__ + "static/img/mainBottom.fe4870a.jpg";


//////////////////
// WEBPACK FOOTER
// ./image/homePage/mainBottom.jpg
// module id = 560
// module chunks = 502